module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG52b7ae90752611adf000da424a858ee2.52b7ae90.png";